import { render, staticRenderFns } from "./ExhibitionMap.vue?vue&type=template&id=2c6c1fa8&scoped=true"
import script from "./ExhibitionMap.vue?vue&type=script&lang=js"
export * from "./ExhibitionMap.vue?vue&type=script&lang=js"
import style0 from "./ExhibitionMap.vue?vue&type=style&index=0&id=2c6c1fa8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6c1fa8",
  null
  
)

export default component.exports